export default __webpack_public_path__ + "assets/images/icon-video.991335be042ff491eebfb8a171ac8c88.svg";